import { AnonymousApp } from '../../singlePageApp/App/AnonymousApp';

export const App = () => {
  return <AnonymousApp />;
};
